module.exports = __webpack_public_path__ + "assets/fcae6803052b6556fb3a4c607d239a4f.mp3";